module.exports = __webpack_public_path__ + "static/media/door09.d4a5cd51.png";